import { inject, NewInstance } from 'aurelia-framework';
import { PurchasePartTypeService } from 'pages/system-fields/purchase-part-types/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), PurchasePartTypeService, EventAggregator)
export class PurchasePartTypeEditor {
    constructor(controller, validationController, purchasePartTypeService, ea) {
        this.controller = controller;
        this.purchasePartTypeService = purchasePartTypeService;
        this.ea = ea;
        this.purchasePartType = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.purchasePartType = await this.purchasePartTypeService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.purchasePartType.id) {
                    await this.purchasePartTypeService.update(this.purchasePartType);
                    toastr.success('Purchase part type was updated!');
                } else {
                    await this.purchasePartTypeService.create(this.purchasePartType);
                    toastr.success('New purchase part type was created!');
                }
                this.ea.publish('purchase-part-types:updated', this.purchasePartType);
                this.controller.ok(this.purchasePartType);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}